export default __webpack_public_path__ + "static/Balasys-favicon-2ae171ce66e398032f082bfe49865b08.svg";